import React from 'react';
import cx from 'classnames';
import * as styles from './OMCheckbox.scss';

const OMCheckbox = (properties) => {
  const { id, label, field, className, withoutLabel, customCheckBox, notValid } = properties;
  return (
    <label
      htmlFor={id || field.value}
      className={cx(
        styles.omCheckbox,
        className,
        customCheckBox,
        { [styles.indent]: field.name === 'entry_date.immediate' },
        { [styles.withoutLabel]: withoutLabel },
        { [styles.not_valid]: notValid }
      )}
    >
      <input id={id || field.value} type="checkbox" {...field} />

      <span>{ label }</span>
    </label>
  );
};

export default OMCheckbox;
